import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Prenota from "@/pages/Prenota";
import Legal from "@/pages/Legal";
import AdminLogin from "@/pages/AdminLogin";
import Admin from "@/pages/Admin";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/prenota" element={<Prenota />} />
        <Route path="/prenota.html" element={<Navigate to="/prenota" replace />} />
        <Route path="/privacy" element={<Legal kind="privacy" />} />
        <Route path="/cookie" element={<Legal kind="cookie" />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Toaster theme="dark" position="top-center" />
    </BrowserRouter>
  );
}

export default App;
